import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
     CCard,
     CCardBody,
     CForm,
     CButton,
     CRow,
     CCol,
} from '@coreui/react';
import { CInput } from '../../../migration/CInput';
import CLabel from '../../../migration/CLabel';
import Select from 'react-select';
import CIcon from '@coreui/icons-react';
import DatePicker from "react-datepicker";

const TEXT_OPTION = [
     { label: 'contains', value: 'li' },
     { label: 'not contains', value: 'nli' },
     { label: 'is empty', value: 'empty' },
     { label: 'is not empty', value: 'notEmpty' },
]

const DATE_TIME_OPTION = [
     { value: 'eq', label: 'is' },
     { value: 'neq', label: 'is not' },
     { value: 'lt', label: 'is less than' },
     { value: 'lte', label: 'is less than or equals to' },
     { value: 'gt', label: 'is greater than' },
     { value: 'gte', label: 'is greater than or equals to' },
]

const defaultFilter = { key: '', condition: 'ct', type: '', value: '' }

const EMPTY_CONDITIONS = ['empty', 'notEmpty'];

const FilterRow = ({ row, onChange, onRemove, fieldOptions, filters }) => {
     const typeDate = row.type === 'datetime'
     const conditionOptions = typeDate ? DATE_TIME_OPTION : TEXT_OPTION;
     const isEmptyCondition = EMPTY_CONDITIONS.includes(row.condition);
     return (
          <CRow className="align-items-end my-2">
               <CCol sm={3}>
                    <CLabel className='text-label'>Field</CLabel>
                    <Select
                         name='key'
                         className={`${!row.field ? 'not-selected' : ''}`}
                         options={fieldOptions}
                         value={fieldOptions.find((item) => item.value === row.key) || null}
                         onChange={e => {
                              const typeValue = e.type === 'datetime';
                              const newData = {
                                   key: e.value,
                                   value: '',
                                   type: e.type,
                              }
                              if (e.type !== row.type) {
                                   newData.condition = typeValue ? 'eq' : 'li'
                              }
                              onChange(newData);
                         }}
                    />

               </CCol>
               <CCol sm={2}>
                    <CLabel className='text-label'>Condition</CLabel>
                    <Select
                         name='condition'
                         className={`${!row.condition ? 'not-selected' : ''}`}
                         options={conditionOptions}
                         value={conditionOptions.find((item) => item.value === row.condition) || null}
                         onChange={e => onChange({
                              condition: e.value,
                              ...(EMPTY_CONDITIONS.includes(e.value) ? { value: '' } : {}),
                         })}
                    />
               </CCol>
               {!isEmptyCondition && (
                    <CCol sm={3}>
                         <CLabel className='text-label'>Value</CLabel>
                         {typeDate ? (
                              <DatePicker
                                   dateFormat="yyyy-MM-dd"
                                   className="form-control"
                                   wrapperClassName='d-block'
                                   selected={row.value ? new Date(row.value) : new Date()}
                                   onChange={date => onChange({ value: date })}
                              />
                         ) : (
                              <CInput
                                   value={row.value}
                                   onChange={e => onChange({ value: e.target.value })}
                              />
                         )}
                    </CCol>
               )}
               {filters?.length > 1 && (
                    <CCol sm={2}>
                         <CIcon
                              name='iconDeleteField'
                              className={`icon-delete`}
                              onClick={() => {
                                   onRemove();
                              }}
                         />
                    </CCol>
               )}

          </CRow>
     )
}

const CFilter = ({ currentFilters, setCurrentFilters, listFields }) => {
     const [filters, setFilters] = useState(currentFilters);
     const fieldOptions = listFields.filter((field) => !field.noFilter).map((field) => ({ value: field.key, label: field.label, type: field.type }));

     const handleFilterChange = (idx, value) => {
          const newFilters = filters.map((f, i) =>
               i === idx ? { ...f, ...value } : f
          )
          setFilters(newFilters)
     }

     const handleAddFilter = () => {
          setFilters([...filters, { ...defaultFilter }])
     }

     const handleRemoveFilter = idx => {
          setFilters(filters.filter((_, i) => i !== idx))
     }

     const handleSubmit = (e) => {
          e.preventDefault();
          const newFilters = filters.filter((_filter) => _filter.key && _filter.condition && (_filter.value || EMPTY_CONDITIONS.includes(_filter.condition)));
          setFilters(newFilters?.length  > 0 ? newFilters : [{ ...defaultFilter }])
          setCurrentFilters(newFilters?.length  > 0 ? newFilters : [{ ...defaultFilter }])
     }

     const handleClear = () => {
          setFilters([{ ...defaultFilter }])
          setCurrentFilters([{ ...defaultFilter }])
     }

     return (
          <CCard className="my-4 filter-admin">
               <CCardBody>
                    <div className="mb-3">
                         <h5>
                              Filters - optional
                         </h5>
                    </div>
                    <CForm onSubmit={handleSubmit}>
                         {filters.map((row, idx) => (
                              <FilterRow
                                   key={idx}
                                   row={row}
                                   onChange={(value) => handleFilterChange(idx, value)}
                                   onRemove={() => handleRemoveFilter(idx)}
                                   fieldOptions={fieldOptions}
                                   filters={filters}
                              />
                         ))}
                         <CButton
                              className='pl-0'
                              onClick={handleAddFilter}
                         >
                              <CIcon name='iconAddField' className='icon-add' />
                              <CLabel className='add-row ml-3'>ADD ROW</CLabel>
                         </CButton>
                         <div className="d-flex mt-3">
                              <CButton type="submit" color="primary" className='mr-3'>
                                   APPLY
                              </CButton>
                              <CButton
                                   type="button"
                                   color="secondary"
                                   onClick={handleClear}
                              >
                                   RESET
                              </CButton>
                         </div>
                    </CForm>
               </CCardBody>
          </CCard>
     )
}

FilterRow.propTypes = {
     row: PropTypes.shape({
          type: PropTypes.string,
          condition: PropTypes.string,
          value: PropTypes.any,
          key: PropTypes.string,
          field: PropTypes.any,
     }),
     onChange: PropTypes.func,
     onRemove: PropTypes.func,
     fieldOptions: PropTypes.array,
     filters: PropTypes.array,
};

CFilter.propTypes = {
     currentFilters: PropTypes.array,
     setCurrentFilters: PropTypes.func,
     listFields: PropTypes.array,
};

export default CFilter